/** Returns true iff `obj` is `{}`, i.e. the empty object. Fastest implementation according to https://stackoverflow.com/a/59787784/8059181 */
export function isEmpty(obj: object): obj is Record<string, never> {
  for (const _ in obj) return false;
  return true;
}
